export const VEHICLE_INSPECTION_GA_SCREEN = {
  RESERVATION_NEW__STEP_1_INFO: 'PUBLIC_SERVICE_VEHICLE_INSPECTION_RESERVATION_NEW__STEP_1_INFO',
  RESERVATION_NEW__STEP_1_DISCOUNT: 'PUBLIC_SERVICE_VEHICLE_INSPECTION_RESERVATION_NEW__STEP_1_DISCOUNT',
  RESERVATION_NEW__STEP_2_PLACE: 'PUBLIC_SERVICE_VEHICLE_INSPECTION_RESERVATION_NEW__STEP_2_PLACE',
  RESERVATION_NEW__STEP_3_PERIOD: 'PUBLIC_SERVICE_VEHICLE_INSPECTION_RESERVATION_NEW__STEP_3_PERIOD',
  RESERVATION_$RESERVATION_NUMBER__STEP_2_PLACE: (reservationNumber: string) =>
    `PUBLIC_SERVICE_VEHICLE_INSPECTION_RESERVATION_${reservationNumber}__STEP_2_PLACE`,
  RESERVATION_$RESERVATION_NUMBER__STEP_3_PERIOD: (reservationNumber: string) =>
    `PUBLIC_SERVICE_VEHICLE_INSPECTION_RESERVATION_${reservationNumber}__STEP_3_PERIOD`,
} as const;
